import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "button-inner" }
const _hoisted_3 = { class: "button-text" }
const _hoisted_4 = { class: "button-icon-left material-icons material-icons-round" }
const _hoisted_5 = {
  key: 0,
  class: "mx-1"
}
const _hoisted_6 = { class: "button-icon-right material-icons material-icons-round" }

import { toRefs } from 'vue';
import Spinner from '../Loader/Spinner.vue';

interface Props {
  text?: string;
  type?: string;
  color?: string;
  size?: string;
  disabled?: boolean;
  iconLeft?: string;
  iconRight?: string;
  fullWidth?: boolean;
  loading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    text: { default: '' },
    type: { default: 'Primary' },
    color: { default: '' },
    size: { default: 'medium' },
    disabled: { type: Boolean, default: false },
    iconLeft: { default: '' },
    iconRight: { default: '' },
    fullWidth: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const { loading, fullWidth, iconRight, iconLeft, type, text } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass([
      'button',
      'button-style-' + _unref(type),
      'button-size-' + __props.size,
      __props.color ? 'button-color-' + __props.color : '',
      _unref(fullWidth) ? 'button-full-width' : '',
      { 'no-text': _unref(text) === '' },
      { 'button-loading': _unref(loading) },
    ]),
    disabled: __props.disabled
  }, [
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("span", {
          class: _normalizeClass(_unref(loading) ? 'spinner-visible' : 'spinner-hidden')
        }, [
          _createVNode(Spinner, {
            size: 18,
            class: "mr-1"
          })
        ], 2),
        _createElementVNode("i", _hoisted_4, _toDisplayString(_unref(iconLeft)), 1),
        (_unref(text))
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(text)), 1))
          : _createCommentVNode("", true),
        _createElementVNode("i", _hoisted_6, _toDisplayString(_unref(iconRight)), 1)
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "button-details" }, null, -1)),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "button-outline" }, null, -1))
    ])
  ], 10, _hoisted_1))
}
}

})